import { render, staticRenderFns } from "./ShopScreen.vue?vue&type=template&id=7ada76f0"
import script from "./ShopScreen.vue?vue&type=script&lang=js"
export * from "./ShopScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports